import { Router } from "@angular/router";
import { SignInRedirect } from "../../../../shared/_guards/sign-in-redirect";
import { saveReturnPath } from "../../../../shared/_guards/return-path";
import { environment } from "../../environments/environment";

// The website's page that signs an admin in, if needed, and hands the token back to this tab (?token=).
export const WEBSITE_ADMIN_URL = `${environment.appUrl}/admin`;

// The dashboard has no sign-in: a signed-out tab saves the path asked for and leaves for the website with a plain
// full-page navigation. It replaces this page in history, so Back from the website does not land on a page that
// leaves again.
export function createDashboardSignInRedirect(router: Router, document: Document): SignInRedirect {
    return (requestedUrl: string): void => {
        saveReturnPath(router, requestedUrl);
        document.location.replace(WEBSITE_ADMIN_URL);
    };
}
